import React from "react";
import Container from "Components/Container/Container";

import GetInTouch from "./GetInTouch/GetInTouch";
import FooterLogo from "./FooterLogo/FooterLogo";
import Navigation from "./Navigation/Navigation";
import Contact from "./Contact/Contact";
const Footer = () => {
  return (
    <footer className="bg-black relative ">
      <GetInTouch />
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-y-6 py-secondary lg:py-primary">
          <FooterLogo />
          <Navigation />
          <Contact />
        </div>
      </Container>

      <div className="py-6 bg-[#101010] border-t border-[#808080]">
        <Container>
          <div className="text-[#808080] text-lg flex flex-col lg:flex-row gap-y-2 lg:items-center justify-between">
            <p>All Right Reserved Martin Proffesional Middle East 2025</p>
            <p>
              By{" "}
              <a
                className="underline"
                rel="noreferrer"
                target="_blank"
                href="https://www.dowgroup.com/"
              >
                Dow Group
              </a>
            </p>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
